import type { SxProps, Theme } from '@mui/material'

export const sectionTitleSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '0.9rem',
  fontWeight: 500,
  mb: 0.5,
  display: 'block',
}

export const sectionDescriptionSx: SxProps<Theme> = {
  fontSize: '0.8rem',
  color: 'text.disabled',
  mb: 2,
}

export const groupContainerSx: SxProps<Theme> = (theme) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(62, 39, 35, 0.03)',
  borderRadius: 1,
  p: 2.5,
  mb: 4,
})

export const groupLabelSx: SxProps<Theme> = {
  fontSize: '0.7rem',
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: 'text.disabled',
  mb: 2.5,
}

export const subContainerSx: SxProps<Theme> = {
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
  p: 2,
}

export const groupDividerSx: SxProps<Theme> = {
  borderColor: 'divider',
  my: 3,
}

export const contentSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
}

export const descriptionSx: SxProps<Theme> = {
  color: 'text.disabled',
  fontSize: '0.8rem',
}

export const actionGroupSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
}

export const actionButtonSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  px: 1.5,
  py: 0.75,
  border: 'none',
  borderRadius: 1,
  backgroundColor: 'transparent',
  cursor: 'pointer',
  transition: 'all 150ms ease-in-out',
  '&:hover': {
    backgroundColor: 'action.hover',
  },
}

export const iconSx: SxProps<Theme> = {
  fontSize: 16,
  color: 'text.secondary',
}

export const buttonLabelSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '0.8rem',
  fontWeight: 500,
}
